import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover object-center"
          aria-label="Arquitetura contemporânea em Ilhabela - Projeto residencial de alto padrão"
          poster="https://public.readdy.ai/ai/img_res/76b476812b91d388d56560644922fc16.jpg"
        >
          <source src="https://public.readdy.ai/ai/video_res/d4bb57d0-46d3-40c3-b1e5-23f0662489b6.mp4" type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-3xl"
        >
          <div className="hidden sm:inline-flex items-center gap-2 px-4 py-2 border border-white/40 rounded-full mb-6 sm:mb-8 backdrop-blur-sm">
            <i className="ri-map-pin-line text-white text-sm"></i>
            <span className="text-white text-sm font-inter">Ilhabela, SP</span>
          </div>

          <h1 className="font-playfair text-white mb-4 sm:mb-6">
            <span className="block text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight">Arquitetura</span>
            <span className="block text-4xl sm:text-5xl lg:text-7xl font-light leading-tight">Contemporânea</span>
            <span className="block text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight">para o Litoral</span>
          </h1>

          <p className="text-white/90 text-base sm:text-lg font-inter font-light mb-6 sm:mb-10 max-w-xl">
            Projetos residenciais autorais em Ilhabela que valorizam a paisagem e o estilo de vida litorâneo
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#projetos"
              className="inline-flex items-center justify-center gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white text-gray-900 text-sm sm:text-base font-inter font-medium rounded-full hover:scale-105 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Conhecer Projetos
              <i className="ri-arrow-right-line text-lg"></i>
            </a>

            <a
              href="https://wa.me/5512974034577"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-6 sm:px-10 py-3 sm:py-5 bg-accent text-white text-sm sm:text-base font-inter font-medium rounded-full hover:bg-accent/90 transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Solicitar Conversa
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="absolute bottom-32 right-4 sm:right-12 hidden lg:block"
        >
          <div className="w-64 p-6 bg-white/95 backdrop-blur-md rounded-2xl shadow-xl">
            <p className="text-sm font-inter text-gray-700 leading-relaxed">
              <strong className="text-gray-900">Especialização em terrenos litorâneos:</strong> desenvolvemos projetos que respeitam a topografia, aproveitam as vistas e garantem conforto térmico em Ilhabela.
            </p>
          </div>
        </motion.div>

        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-white text-xs font-inter tracking-wider rotate-0">SCROLL</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-px h-12 bg-white/60"
          ></motion.div>
        </div>
      </div>
    </section>
  );
}
